<template>
    <div class="fluid page_content list_users" v-if="permission && permission.version === '5'">

    <div class="row pg_hd">
      <div class="col-6 hd" role="heading" aria-level="1">
        <div class="hd_ic">
          <span class="ic icon-mentor"></span>
        </div>
        <div class="ace_sec_txt hd_txt">
          <span class="hd_txt_inner">
            {{ $t('userManagement') }}
          </span>
          <span class="hd_info">
            (<select v-model="pageSize" @change="resetNumber" aria-label="page size" class="page_size">
              <option v-for="option in sizeOptions" v-bind:value="option">
                {{ option }}
              </option>
            </select> / {{ numberOfElements }})
            <!--
            {{ $t('showing') }}: {{ option }} out of {{ numberOfElements }}
            -->
          </span>
        </div>
      </div>

      <div class="col-6 btn_container pg_hd_rgt_sec">
        <div class="row">

          <div class="col-5 btn_container pagination_sty3">
            <b-button
              v-on:click="prev"
              class="btn btn_trans"
              :disabled="firstPage"
              :title="$t('previousPage')" :aria-label="$t('previousPage')"
              v-b-tooltip.hover><span class="ic2_arr_pre3" aria-hidden="true"></span></b-button>
            <span
              class="page_info"
              style="float: left;">
              <b-dropdown
                variant="outline-secondary"
                class="pagination_dropdown"
              >
              <template #button-content class="ic_btn btn_pg_switch">
                <span class="current">{{ number + 1 }}</span>
                <span class="total">({{ totalPages }})</span>
              </template>
                <b-dropdown-item
                  v-for="p in totalPages"
                  :key="p"
                  @click="goToPage(p)"
                  :active="p === selectedPageUI"
                >
                  Page {{ p }}
                </b-dropdown-item>
              </b-dropdown>
            </span>
            <b-button
              v-on:click="next"
              class="btn btn_trans"
              style="float: left;"
              :disabled="lastPage"
              :title="$t('nextPage')" :aria-label="$t('nextPage')"
              v-b-tooltip.hover><span class="ic2_arr_next3" aria-hidden="true"></span></b-button>
          </div>
          <div class="col-7" style="max-width: fit-content;">
            <button v-if="isShowCreateByEmail" @click="redirectToCreateUserByEmail" class="btn btn-primary" aria-label="create by emails">create by emails</button>
            <button @click="redirectToCreateUser" class="btn btn-primary" aria-label="create" :disabled="permission.systemPermission.readOnly">new</button>
            <button class="btn btn-primary" aria-label="upload" :disabled="!permission.userPermission.create" @click="uploadUserClicked">upload</button>
          </div>
        </div>
      </div>

    </div>


      <div class="page_content_container list_page" style="float: left;">
          <b-row>
	          <div class="col-xl-3 col-lg-3 col-md-4 col-sm-4 facets ace_sec" aria-label="facets section">
	            <div class="main_head">
	              <span class="icon-filter"></span>
	              <span class="head_txt ace_sec_txt" role="heading" aria-lavel="1">Narrow Your Results</span>
	            </div>

	            <div class="facet_block_container">
					           <!-- TODO ensure the "X" clear button appears on the same row as the preceeding 'search by name' input tag  -->
					     <div class="search_field">
             		 <input v-model="name" placeholder="search by name" aria-label="search by name" @input="resetNumber" style="float: left;">
                  <template v-if="this.name.length > 0">
      							<b-btn class="btn_clear" @click="loadUserList" aria-label="clear" title="clear">
      								<span class="ic-close" @click="name = ''"></span>
      							</b-btn>
                  </template>
                </div>

	              <div class="entity-column">
	                <div class="facet_block">
	                  <div class="head">
	                    <div class="checkbox">
	                      <b-form-checkbox @change="selectAllUserRolesClicked" aria-label="select all roles" v-model="selectAllUserRoles"></b-form-checkbox>
	                    </div>
	                    <div class="head_txt">Role</div>
	                    <div class="icon_container">
	                    	<b-collapse visible id="icCollapse">
	                      		<b-btn v-b-toggle.userRole.icExpand.icCollapse>
	                        		<span class="collapsed icon-collapse" aria-label="collapse"></span>
	                      		</b-btn>
	                      	</b-collapse>
	                      	<b-collapse id="icExpand">
	                      		<b-btn v-b-toggle.userRole.icCollapse.icExpand>
	                        		<span class="expand icon-expand" visible aria-label="expand"></span>
	                      		</b-btn>
	                      	</b-collapse>
	                    </div>
	                  </div>
	                  <b-collapse visible id="userRole">
	                    <div class="facet_row_container">
	                      <b-form-group>
	                        <b-form-checkbox-group plain stacked v-model="selectedRoles" :options="userRoles" @input="resetNumber" />
	                      </b-form-group>
	                    </div>
	                  </b-collapse>

	                  </div>
	                  </div>

	                </div><!-- facet_block_container -->
	              </div><!-- facets -->

                <div class="col-xl-9 col-lg-9 col-md-8 col-sm-8 table_containers">

                  <!-- TODO add class user-management-table back to <table> tag and ensure it can handle 4 columns -->
                  <table v-if="isUsersLoaded" class="table">
                    <thead class="thead-light">
                      <tr>
                        <td class="first-column col-4 col_name">Name</td>
                        <td class="second-column col-3 col_id">External Id</td>
                        <td class="third-column col-3 col_role">Role</td>
                        <td class="action-column col-2 col_action">Action</td>
                      </tr>
                    </thead>
                    <tbody v-if="users.length > 0">
                      <tr v-for="user in users" :class="user.suspended ? 'suspended':''" :title="user.suspended ? 'user suspended':''" v-b-tooltip.hover>
                        <td class="first-column col-4 col_name">
                          <div>
                            <div class="usr_name" v-b-tooltip.hover :title="user.firstName + ' ' + user.lastName">
                              <div class="ic" :class="'ic_' + user.roles[0].role.replace(/[^a-zA-Z0-9_-]/g, '')"></div>
                              <div class="val">{{ user.firstName }} {{ user.lastName }}</div>
                            </div>
                            <template v-if="user.suspended">

                            </template>
                          </div>
                        </td>
                        <td class="second-column col-3 col_id">
                          <span v-b-tooltip.hover :title="user.externalId">
                            {{ user.externalId }}
                          </span>
                        </td>
                        <td class="third-column col-3 col_role">
                          <span v-b-tooltip.hover :title="user.roles[0].role">
                            {{ user.roles[0].role }}
                          </span>
                        </td>
                        <td class="action-column col-2 col_action">
                          <template v-if="permission.systemPermission.readOnly">
                            <span class="ic_btn ic_pencil" aria-label="edit" tabindex="0" style="pointer-events: none; color: #ccc;"></span>
                            <span class="ic_btn ic_bin" aria-label="delete" tabindex="0" style="pointer-events: none; color: #ccc;"></span>
                          </template>
                          <template v-else>
                            <template v-if="isEmailChangeEnabled" >
                            <b-btn class="ic_btn ic_editEmail1" aria-label="email" tabindex="0" @click="showChangeEmailBox(user.uuid)"
                            v-b-tooltip.hover title="change email"></b-btn>
                            </template>
                            <b-btn class="ic_btn ic_pencil" aria-label="edit" tabindex="0" @click="editUser(user.uuid)"
                            v-b-tooltip.hover title="edit"></b-btn>
                            <b-btn class="ic_btn ic_bin" aria-label="delete" tabindex="0" @click="showDeleteFolderConfirmBox(user.uuid)" style="cursor: pointer;" v-b-tooltip.hover title="delete">
                            </b-btn>
                          </template>
                        </td>
                      </tr>
                    </tbody>
                    <tbody v-else class="no-result">
                      <tr>No Results Found</tr>
                    </tbody>
                  </table>
                </div>
              </b-row>
        </div>

        <div>
            <b-modal class="delete-folder-popup" ref="deleteUserModal" :title="'Please Confirm!'" ok-disabled cancel-diasbled hide-header-close no-close-on-backdrop no-close-on-esc centered>
                <div>
                    <span>{{ userDeleteMessage }}</span>
                </div>
              <div slot="modal-header" class="popover-header">
                <div class="popup-heading">Please Confirm!</div>
                <button class="btn_close" aria-label="close" @click="hideDeleteConfirmBox">
                   <span class="ic-close"></span>
                </button>
              </div>
              <div slot="modal-footer" class="w-100">
                  <b-button @click="deleteUserAndHideDeleteConfirmBox" class="btn button-primary float-right mr-2" aria-label="yes"> yes </b-button>
                  <b-button @click="hideDeleteConfirmBox" class="btn button-primary float-right mr-2" aria-label="no"> no </b-button>
              </div>
            </b-modal>
        </div>

        <div>
            <b-modal class="modal__v22_2" ref="changeEmailModal" ok-disabled cancel-diasbled hide-header-close no-close-on-backdrop no-close-on-esc centered>
              <div slot="modal-header" class="header-section">
                <div class="hd_txt">Please Confirm!</div>
                <div class="close_btn_container">
                  <button class="btn_close" aria-label="close" @click="hideChangeEmailBox">
                    <span class="ic-close"></span>
                  </button>
                </div>
              </div>

              <div class="row">
                <div class="col-11" style="margin: 0 auto;">

                  <div class="row fld_row">
                    <div class="col-4 fld_label">
                      Current Email
                    </div>
                    <div class="col-8 fld_val">
                      {{ userEmailChange }}
                    </div>
                  </div>
                  <div class="row fld_row mt-4">
                    <div class="col-4 fld_label">
                      New Email
                    </div>
                    <div class="col-8 fld_input">
                      <b-form-input type="email" v-model.email="userNewEmail" :state="eMailState"
                          aria-labelledby="new email for user" placeholder="new email for user" @blur.native="$v.userNewEmail.$touch()"
                          aria-describedby="eMailFeedback" style="height: 1.5em !important; width: 80%; margin-top: -5px;" autofocus>
                      </b-form-input>
                      <b-form-invalid-feedback id="eMailFeedback">
                          Please enter a proper email address.
                      </b-form-invalid-feedback>
                    </div>
                  </div>

                </div>
              </div>

              <div slot="modal-footer">
                <div class="btn_container">
                  <b-button @click="updateEmailForUser" class="btn button-primary float-right mr-2" aria-label="yes"> ok </b-button>
                  <b-button @click="hideChangeEmailBox" class="btn button-primary float-right mr-2" aria-label="no"> cancel </b-button>
                </div>
              </div>
            </b-modal>
        </div>

        <div class="loading-spinner">
            <b-modal style="padding: 0px;" ref="loadingModal" hide-header hide-footer no-close-on-backdrop no-close-on-esc size="sm" centered>
                <div class="text-center" style="color: #FFF">
                    <i class="fa fa-spinner fa-3x fa-fw fa-pulse"></i>
                </div>
            </b-modal>
        </div>

    </div>
</template>

<script>
  import Vue from 'vue'
  import { mapActions, mapState } from 'vuex'
  import Autocomplete from 'vuejs-auto-complete'
  import Vuelidate from 'vuelidate'
  import {required, email} from 'vuelidate/lib/validators'
  import '../../../assets/module/css/user/userList.min.css'

  export default {
    name: 'listUsers',
    props: ['parentSpaceId'],
    data () {
      return {
        sizeOptions: [ 10, 50, 100 ],
        pageSize: 10,
        firstPage: true,
        lastPage: false,
        number: 0,
        totalPages: 0,
        numberOfElements: 0,
        users: [],
        userRoles: ['Instructor & Admin', 'Employer Admin', 'Instructor', 'Observer', 'Curator', 'Advisor', 'Student', 'Coach', 'Recruiter', 'Prospective Student', 'Admitted Student', 'Widget Admin'],
        selectedRoles: ['Instructor & Admin', 'Employer Admin', 'Instructor', 'Observer', 'Curator', 'Advisor', 'Student', 'Coach', 'Recruiter', 'Prospective Student', 'Admitted Student', 'Widget Admin'],
        isUsersLoaded: false,
        name: '',
        isShowUserFilterPopup: false,
        isShowCreateByEmail: false,
        userDeleteMessage: '',
        userToBeDeleted: '',
        userEmailChange:'',
        userNewEmail: '',
        selectAllUserRoles: true,
        eMailState: null,
        selectedPageUI: 1
      }
    },

    mounted () {
      this.loadPermission().then(res => {
        this.showLoader()
        setTimeout(() => {
          this.loadUserList()
        }, 500)
      })
    },

    computed: {
      ...mapState({
        'permission': state => state.user.permission,
        'enabledFeatures': state => state.institution.enabledFeatures

      }),
      currentInstitutionId () {
        let userObj = JSON.parse(localStorage.getItem('userobj'))
        let institutionId = this.parentSpaceId
        return institutionId || userObj.institutionId
      },
      isEmailChangeEnabled () {
        let emailChangeFeature = this.enabledFeatures['allowAdminToChangeEmail']
        return emailChangeFeature && emailChangeFeature.enabled
      },
      loggedInUserId () {
        var userObj = JSON.parse(localStorage.getItem('userobj'))
        return userObj.uuid
      },

      processedRoles () {
        var i = 0
        var role = ''
        var len = this.selectedRoles.length
        for (i = 0; i < len; i++) {
          role = role + encodeURIComponent(this.selectedRoles[i])
          if (i !== len - 1) {
            role = role + '|'
          }
        }
        return role
      }
    },

    methods: {
      ...mapActions([
        'loadUsers',
        'loadUser',
        'updateUserEmail',
        'loadDeleteUser',
        'loadPermission'
      ]),
      loadUserList () {
        this.loadUsers({parentSpaceId: this.currentInstitutionId, page: this.number, count: this.pageSize, role: this.processedRoles, name: this.name}).then(res => {
          this.users = res.content
          this.isUsersLoaded = true
          this.firstPage = res.first
          this.lastPage = res.last
          this.number = res.number
          this.totalPages = res.totalPages
          this.numberOfElements = res.totalElements
          this.hideLoader()
        })
      },
      resetNumber () {
        this.number = 0
        this.loadUserList()
      },
      getUser (userId) {
        this.loadUser(userId).then(res => {
          this.userEmailChange = res.eMail
        })
      },
      prev () {
        this.number = this.number - 1
        this.loadUserList()
      },
      next () {
        this.number = this.number + 1
        this.loadUserList()
      },
      goToPage (uiPage) {
        if (uiPage === this.selectedPageUI) return

        this.showLoader()

        this.selectedPageUI = uiPage      // UI page (1-based)
        this.number = uiPage - 1          // API page (0-based)

        this.loadUserList()
      },
      showChangeEmailBox (userId) {
        this.getUser(userId)
        this.$refs.changeEmailModal.show()
      },
      updateEmailForUser () {
        this.$v.userNewEmail.$touch()
        if (this.$v.userNewEmail.$error) {
          this.eMailState = false
        }
        if (this.eMailState) {
          if (this.userEmailChange && this.userNewEmail) {
            this.updateUserEmail({oldEmail:this.userEmailChange, newEmail:this.userNewEmail}).then(res => {
              if(res.indexOf('Successfully') !=-1) {
                this.$notify({
                  group: 'notify',
                  type: 'success',
                  title: '',
                  text: 'Successfully updated email for the user.'
                })
                this.hideChangeEmailBox()
                this.loadUserList()
                this.eMailState = null
                } else {
                  this.$notify({
                    group: 'notify',
                    type: 'error',
                    title: '',
                    text: res
                  })
                }
            })
          }
        }
      },
      hideChangeEmailBox () {
        this.userEmailChange = ''
        this.userNewEmail = ''
        this.eMailState = null
        this.$refs.changeEmailModal.hide()
      },
      showDeleteFolderConfirmBox (uuid) {
        this.userToBeDeleted = uuid
        this.userDeleteMessage = 'Are you sure you would like to delete this user?'
        this.$refs.deleteUserModal.show()
      },
      deleteUserAndHideDeleteConfirmBox () {
        this.$refs.deleteUserModal.hide()
        this.deleteUser()
      },
      deleteUser () {
        if (this.userToBeDeleted) {
          this.loadDeleteUser(this.userToBeDeleted).then(res => {
          if(res==='NOT_AUTHORIZE'){
              this.$notify({
                group: 'notify',
                type: 'error',
                title: '',
                text: 'You are not authorize to delete this user, Please contact support.'
              })
          }else{
              this.$notify({
                group: 'notify',
                type: 'success',
                title: '',
                text: 'Successfully deleted the user.'
              })
              this.loadUserList()
              }
          })
        }
      },
      hideDeleteConfirmBox () {
        this.userToBeDeleted = ''
        this.$refs.deleteUserModal.hide()
      },
      editUser (uuid) {
        return this.$router.push({ name: 'editUser', params: { uuid: uuid, parentSpaceId: this.currentInstitutionId } })
      },
      redirectToCreateUser () {
        return this.$router.push({ name: 'createUser', params: { parentSpaceId: this.currentInstitutionId } })
      },
      redirectToCreateUserByEmail () {
        return this.$router.push({ name: 'createUserByEmail', params: { parentSpaceId: this.currentInstitutionId } })
      },
      toggleUserFilterPopup () {
        this.isShowUserFilterPopup = !this.isShowUserFilterPopup
        $('.search_field').toggleClass('popover-style')
      },
      uploadUserClicked () {
        return this.$router.push({name: 'userUpload'})
      },
      selectAllUserRolesClicked () {
        let selectedRoles = []
        this.userRoles.forEach(function (role) {
          selectedRoles.push(role.slice())
        })
        if (!this.selectAllUserRoles) {
          this.selectedRoles = selectedRoles
        } else {
          this.selectedRoles = []
        }
      },
      showLoader () {
        if (this.$refs.loadingModal) {
          this.$refs.loadingModal.show()
        }
      },
      hideLoader () {
        if (this.$refs.loadingModal) {
          this.$refs.loadingModal.hide()
        }
      }
    },

    validations: {
      userNewEmail: {
        required,
        email
      }
    },

    watch: {
      userNewEmail (val) {
        if (val) {
          this.eMailState = true
        } else {
          this.eMailState = null
        }
      }
    }
  }
</script>

<style scoped>
  .modal__v22_2 .modal-header .hd_txt {
    padding-bottom: 0px;
    margin-top: 0px;
  }
</style>



// WEBPACK FOOTER //
// src/app/user/components/ListUsers.vue